/**
 * ช่อง "จำนวนสินค้าต่อหน้า (per_page)" ใน modal Control Product
 * ERP ใช้ค่านี้ override perpage ที่หน้าเว็บส่งมา (NULL = ไม่ override)
 * ไฟล์นี้ไม่มี import เพื่อให้ `node --test` รันเทสเดี่ยว ๆ ได้ (webpack import จาก .vue ได้ตามปกติ)
 */
export const PER_PAGE_MAX = 500; // ตรงกับ validation ฝั่ง ERP (max:500)

/**
 * ค่าเริ่มต้นของช่อง per_page ใน modal "เพิ่มหมวดใหม่" ต่อ section
 * ตรงกับ perpage ที่หน้าเว็บ (wre-frontend) ส่งอยู่จริง ตรวจ 2026-09-05:
 *   Home Carousel → หน้าแรก (AllProductFetch)                 = 12
 *   Category      → หน้าหมวดสินค้า (products/page + ProductSection) = 15
 *   Location      → หน้าวัด (GetTemple → ProductSection)      = 15
 *   ข้อยกเว้น: /temples product_list "พวงหรีดใกล้วัดพวงหรีดแนะนำ" ส่ง 30 — แอดมินแก้เอง
 * ถ้าเปลี่ยน perpage ในหน้าเว็บ ต้องแก้ตารางนี้ให้ตรงด้วย
 */
export const DEFAULT_PER_PAGE_BY_SECTION = {
  "Home Carousel": 12,
  Category: 15,
  Location: 15,
};

/** คืนค่าเป็น string สำหรับใส่ใน input; section ที่ไม่รู้จัก → "" (ไม่ override) */
export function defaultPerPageFor(section) {
  const v = DEFAULT_PER_PAGE_BY_SECTION[section];
  return v ? String(v) : "";
}

/**
 * @param {string} text ค่าจาก input
 * @param {{ emptyAs: "omit" | "clear" }} opts
 *   omit  = ค่าว่างไม่ส่ง field (ใช้ตอนเพิ่ม → ERP บันทึก NULL)
 *   clear = ค่าว่างส่ง "" เพื่อล้างค่าเดิม (ใช้ตอนแก้ไข; ConvertEmptyStringsToNull ของ backoffice
 *           แปลง "" → null แล้ว ControlProductController ส่งต่อไป ERP เป็น JSON เพื่อให้ null ไม่หาย → ERP ล้างค่า)
 * @returns {{ value?: number | "" | undefined, error?: string }}
 */
export function parsePerPageInput(text, opts) {
  const trimmed = String(text == null ? "" : text).trim();
  if (trimmed === "") {
    return { value: opts.emptyAs === "clear" ? "" : undefined };
  }
  if (!/^\d+$/.test(trimmed)) {
    return { error: "จำนวนสินค้าต่อหน้าต้องเป็นจำนวนเต็มบวก" };
  }
  const value = parseInt(trimmed, 10);
  if (value < 1 || value > PER_PAGE_MAX) {
    return { error: `จำนวนสินค้าต่อหน้าต้องอยู่ระหว่าง 1 ถึง ${PER_PAGE_MAX}` };
  }
  return { value };
}
